import { createSelector } from 'reselect'
import gameDataSelector from './game_creation_tool_data'

const gameUidSelector = state => {
	const game = gameDataSelector(state)
	return game.uid
}

const activityUidSelector = (state, activityId) => {
	const game = gameDataSelector(state)
	const activity = game.activities.find(activity => activity.id === activityId)
	return activity ? activity.serverId : ''
}

const answerUidSelector = (state, activityId, answerId) => {

	let answerUid = ''

	const game = gameDataSelector(state)
	const activity = game.activities.find(activity => activity.id === activityId)
	if (activity) {
		const answer = activity.answers.find(answer => answer.id === answerId)
		if (answer && answer.serverId) {
			answerUid = answer.serverId
		}
	}
	return answerUid
}

export default createSelector(
	[ gameUidSelector, activityUidSelector, answerUidSelector],
	(gameUid, activityUid, answerUid) => ({
		gameUid,
		activityUid,
		answerUid,
	})
)
